import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  baseTitle = 'SMMOF'

  constructor(
    private browserTitleService: Title,
    private metaService: Meta,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  init() {
    this.router.events
      .pipe(
        filter((event) => event instanceof RoutesRecognized),
        map((event: RoutesRecognized) => {
          let route = event.state.root;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        map((route) => route.data)
      )
      .subscribe((data) => {
        if (data.title) {
          this.setTitle('- ' + data.title);
        } else {
          this.setTitle('');
        }
      });
  }

  // Метод для динамического обновления заголовка
  setTitle(title: string) {
    this.browserTitleService.setTitle(`${this.baseTitle} ${title}`);
  }

  setMetaTags(tags: { [key: string]: string }) {
    for (const name in tags) {
      if (name.startsWith('og:')) {
        this.metaService.updateTag({ property: name, content: tags[name] });
        continue;
      }

      this.metaService.updateTag({ name, content: tags[name] });
    }
  }
}
